import script from "./CustomerAddressesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerAddressesModal.vue?vue&type=script&setup=true&lang=js"

import "./CustomerAddressesModal.vue?vue&type=style&index=0&id=67bd8a20&scoped=true&lang=css"
import "./CustomerAddressesModal.vue?vue&type=style&index=1&id=67bd8a20&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67bd8a20"]])

export default __exports__